var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('feather-icon',{attrs:{"title":"Voir BR","icon":"EyeIcon","svgClasses":"h-5 w-5 hover:text-danger cursor-pointer"},on:{"click":_vm.goToDetailFacture}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }